import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Illustration, IllustrationComponent } from '@ftr/foundation'
import { ComplexFilterSection, ComplexFilterService } from '../../../complex-filter'

export enum ComplexListEmptyStateType {
  Recording = 'recording',
  Transcript = 'transcript',
  AuditLog = 'audit-log',
}

@Component({
  standalone: true,
  selector: 'ftr-complex-list-empty',
  templateUrl: './complex-list-empty.component.html',
  styleUrls: ['./complex-list-empty.component.css'],
  imports: [IllustrationComponent],
})
export class ComplexListEmptyComponent {
  @Input() config: ComplexFilterSection[]
  @Input() hasAppliedFilters: boolean
  @Input() emptyStateType: ComplexListEmptyStateType
  @Input() entityName = 'orders'

  @Output() toggled = new EventEmitter<boolean>()

  readonly emptyStateTypes = ComplexListEmptyStateType
  readonly illustration = Illustration

  constructor(private readonly complexFilterService: ComplexFilterService) {}

  async clearAll(): Promise<void> {
    const filters = this.complexFilterService.getFilters(this.config)
    await this.complexFilterService.clearAll(filters)
  }

  toggleFilters(): void {
    this.toggled.emit(true)
  }
}
